"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.showAltProvidersSection = exports.showCareTeamSection = exports.showReviewSection = exports.showInsuranceSection = exports.showExpertiseSection = exports.showClinicalInterestsSection = exports.isProviderCompatibleWithOpenScheduling = exports.showAppointmentsSection = exports.showAboutSection = exports.getAboutSectionSummaryData = exports.getProviderPhone = exports.getSpecialtyItems = exports.pruneIgnoredValues = exports.pruneIgnoredNetworkAffiliations = exports.getReviewDateString = exports.getReviewStarCount = exports.getVideoUrl = exports.summaryDataConfigHasProviderData = exports.isUrlYouTube = exports.isDebugMode = exports.extractProviderDataContent = exports.getAvailableWithinDays = exports.isSummaryDataConfigured = exports.sortByName = exports.getAvailabilityProps = exports.checkIfShouldRenderAvailability = exports.formatYouTubeVideoUrlToEmbed = exports.insertBetweenItems = exports.sortByAlpha = exports.debounce = exports.getProviderDisplayName = void 0;
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
const get_1 = __importDefault(require("lodash/get"));
const provider_components_1 = require("@kyruus/provider-components");
const constants_1 = require("./constants");
const types_1 = require("../types");
const moment_1 = __importDefault(require("moment"));
const utilities_1 = require("../components/ScheduleAppointment/utilities");
const utilities_2 = require("../components/OpenScheduling/utilities");
var provider_components_2 = require("@kyruus/provider-components");
Object.defineProperty(exports, "getProviderDisplayName", { enumerable: true, get: function () { return provider_components_2.getProviderDisplayName; } });
/**
 * Returns a function that waits ${timeout} to run when invoked and only runs if no other invocations happen
 * @param {function} `fn` function to debounce
 * @param {number} `timeout` ms to wait for invocations
 * @returns {function} debouncedFn
 */
const debounce = (fn, timeout = 200) => {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => fn.apply(this, args), timeout);
    };
};
exports.debounce = debounce;
/**
 * Returns a sort function that sorts alphabetically
 * @param {object} `{ order: 'asc' | 'desc' }` the sort order
 * @returns {function} (a: string, b: string) => number
 */
const sortByAlpha = ({ order = 'asc' } = {}) => (a, b) => order == 'asc' ? a.localeCompare(b) : b.localeCompare(a);
exports.sortByAlpha = sortByAlpha;
/**
 * Takes an array and inserts something between its items
 * @param {arr} `array` input array
 * @param {insert} thing to insert
 * @returns {array}
 */
const insertBetweenItems = (arr, insert) => arr.reduce((acc, item, index) => {
    const isLastItem = index === arr.length - 1;
    if (isLastItem) {
        return [...acc, item];
    }
    return [...acc, item, insert];
}, []);
exports.insertBetweenItems = insertBetweenItems;
/**
 * Parses a YouTube oEmbed object to an embed url
 * @param {object} `data` the YouTube oEmbed json response data
 * @returns {string} embedUrl
 */
const parseYouTubeOembedDataToEmbedUrl = (data) => {
    const { html } = data;
    const tempElem = document.createElement('template');
    tempElem.innerHTML = html;
    const iframe = tempElem.content.querySelector('iframe');
    const embedUrl = iframe === null || iframe === void 0 ? void 0 : iframe.getAttribute('src');
    tempElem.remove();
    return embedUrl;
};
/**
 * Converts a YouTube watch url to an embed url
 * @param {string} `url` the YouTube /watch?v=${video.id} url
 * @returns {string} `embedUrl`
 */
const formatYouTubeVideoUrlToEmbed = (url) => __awaiter(void 0, void 0, void 0, function* () {
    const isEmbedFormat = url.indexOf('embed') !== -1;
    if (isEmbedFormat) {
        return url;
    }
    const resp = yield fetch(`https://youtube.com/oembed/?${new URLSearchParams({
        url,
        format: 'json'
    }).toString()}`, {
        method: 'GET',
        mode: 'cors'
    });
    if (!resp.ok) {
        throw new Error('Error fetching youtube oembed data');
    }
    const data = yield resp.json();
    const embedUrl = parseYouTubeOembedDataToEmbedUrl(data);
    if (!embedUrl) {
        throw new Error('Error parsing youtube oembed data');
    }
    return embedUrl;
});
exports.formatYouTubeVideoUrlToEmbed = formatYouTubeVideoUrlToEmbed;
/**
 * Function to determine if availability should render and type guard availability props
 * The main indicator of this should be the presence of apptInfo, but we can't render if we don't have
 * the tile creator function or the edit callback, and would want to stick with the button
 * @param props An object containing the possibly undefined props we're checking to render availability
 * @returns Boolean Type predicate confirming whether we should render availability/props are defined
 */
const checkIfShouldRenderAvailability = (props) => !!props.apptInfo && !!props.availabilityTileFactory && !!props.onEditApptInfo;
exports.checkIfShouldRenderAvailability = checkIfShouldRenderAvailability;
const getAvailabilityProps = (props) => {
    const enabled = Boolean(props.apptInfo) && Boolean(props.onEditApptInfo);
    return {
        enabled,
        apptInfo: props.apptInfo,
        availabilityByLocationId: props.availabilityByLocationId,
        availabilityTileFactory: props.availabilityTileFactory,
        onEditApptInfo: props.onEditApptInfo
    };
};
exports.getAvailabilityProps = getAvailabilityProps;
/**
 * Sorts an array of objects by the `.name` property in alphabetically ascending order (does not mutate array)
 * @param {array} `objects` the array to sort
 * @returns {array} `sortedObjects` a cloned array sorted by .name ascending
 */
const sortByName = (objects) => {
    const array = (0, cloneDeep_1.default)(objects);
    return array.sort((a, b) => a.name.localeCompare(b.name));
};
exports.sortByName = sortByName;
/**
 * Takes in a provider field name and a customer config object and returns whether or not to show the field in the profile
 * @param {string} `fieldName` the field to check
 * @param {PMCConfig} `customerConfig` the customer config
 * @returns {boolean} whether or not to render the field in the profile
 */
const isSummaryDataConfigured = (fieldName, customerConfig) => {
    var _a;
    // if no summary_data config exists
    if (!((_a = customerConfig === null || customerConfig === void 0 ? void 0 : customerConfig.provider_v9) === null || _a === void 0 ? void 0 : _a.summary_data) ||
        !Array.isArray(customerConfig.provider_v9.summary_data)) {
        return false;
    }
    // if { field: fieldName } exists in summary_data config
    if (customerConfig.provider_v9.summary_data.find(({ field }) => field === fieldName)) {
        return true;
    }
    // otherwise, return false
    return false;
};
exports.isSummaryDataConfigured = isSummaryDataConfigured;
/**
 * Takes in a soonest appointment UTC date
 * @param soonestAppointmentDate {string} The UTC date of the provider's soonest appointment
 * @returns {number} returns appointment available days within {x} days
 */
const getAvailableWithinDays = (soonestAppointmentDate) => {
    const daysFromNowMs = new Date(soonestAppointmentDate).valueOf() - new Date().valueOf();
    const msPerDay = 12 * 2 * 60 * 60 * 1000;
    return Math.ceil(daysFromNowMs / msPerDay) || 0;
};
exports.getAvailableWithinDays = getAvailableWithinDays;
/**
 * Provider data getter
 * @param fieldConfig config.provider_v9.summary_data field config
 * @param provider ProviderMatchProviderV9 object
 * @returns {string | boolean | null} provider data if it exists, null otherwise
 */
const extractProviderDataContent = (fieldConfig, provider) => {
    const { field, subfield, ignore } = fieldConfig;
    const data = (0, get_1.default)(provider, field, null);
    if (typeof data === 'boolean') {
        if (Array.isArray(ignore) && ignore.includes(data.toString())) {
            return null;
        }
        return data;
    }
    if ((typeof data === 'string' || typeof data === 'number') && Boolean(data)) {
        if (Array.isArray(ignore) && ignore.includes(data.toString())) {
            return null;
        }
        return String(data);
    }
    if (Array.isArray(data)) {
        // assume all items are strings if first item is a string
        if (typeof data[0] === 'string' || typeof data[0] === 'number') {
            if (Array.isArray(ignore)) {
                return data.filter((d) => !ignore.includes(String(d))).join('\n');
            }
            return data.join('\n');
        }
        // otherwise assume items are objects
        if (typeof data[0] === 'object' && subfield) {
            return data
                .reduce((acc, item) => {
                const fieldData = item[subfield];
                if (Array.isArray(ignore) && ignore.includes(String(fieldData))) {
                    return acc;
                }
                return [...acc, fieldData];
            }, [])
                .join('\n');
        }
        return null;
    }
    return null;
};
exports.extractProviderDataContent = extractProviderDataContent;
/**
 * Checks to see if the `debug_provider_profile` cookie is set to true
 * @returns {boolean} whether or not the cookie exists and is set to true
 */
const isDebugMode = () => {
    if (typeof window === 'undefined') {
        return false;
    }
    const hasDebugCookie = document &&
        document.cookie &&
        document.cookie.includes('debug_provider_profile');
    if (!hasDebugCookie) {
        return false;
    }
    return document.cookie.includes('debug_provider_profile=true');
};
exports.isDebugMode = isDebugMode;
/**
 * Checks to see if a given url is a YouTube url
 * @returns {boolean}
 */
const isUrlYouTube = (url) => url.indexOf('youtube') !== -1 || url.indexOf('youtu.be') !== -1;
exports.isUrlYouTube = isUrlYouTube;
/**
 * Checks to see if a piece of config.provider_v9.summary_data exists on a provider
 * @param fieldConfig config.provider_v9.summary_data field config
 * @param provider ProviderMatchProviderV9 object
 * @returns {boolean} whether or not the data exists on the provider
 */
const summaryDataConfigHasProviderData = (fieldConfig, provider) => {
    if ((0, exports.extractProviderDataContent)(fieldConfig, provider) !== null) {
        return true;
    }
    return false;
};
exports.summaryDataConfigHasProviderData = summaryDataConfigHasProviderData;
/**
 * Returns the video url for a provider.
 * Corrects invalid vimeo urls and returns all others without a change
 *
 * @param url
 * @returns url
 */
const getVideoUrl = (url) => {
    if (url.includes('vimeo')) {
        const match = url.match(/vimeo.com(.*)?\/(\d+)/);
        if (match && match[2]) {
            const videoId = match[2];
            return `${constants_1.VIMEO_VIDEO_BASE_URL}/${videoId}`;
        }
    }
    return url;
};
exports.getVideoUrl = getVideoUrl;
/**
 * Return a normalized star count based on a review rating and
 * a guess of the rating scale. Each rating data object does not include the original scale.
 *
 * e.g If the rating is 6, this will guess that the rating scale is 1-10 then convert
 * the star count to 60% of PROVIDER_RATING_SCALE
 *
 * @param {number} rating rating value
 * @returns {number}
 */
const getReviewStarCount = (rating = 1) => {
    const starRating = !rating ? 1 : rating;
    const ratingScale = provider_components_1.DEFAULTS.PROVIDER_RATING_SCALE;
    const scaleEnd = Math.ceil(starRating / ratingScale) * ratingScale;
    const percentOfScale = starRating / scaleEnd;
    return Math.max(0, Math.min(ratingScale, Math.round(ratingScale * percentOfScale)));
};
exports.getReviewStarCount = getReviewStarCount;
/**
 * Returns a formatted date string for a review
 * @param {string} date a review date string
 * @returns {string} formatted date string m/d/yyyy
 */
const getReviewDateString = (date) => (0, moment_1.default)(date).format('M/D/YYYY');
exports.getReviewDateString = getReviewDateString;
/**
 * Prunes ignored values off the provider.network_affiliations list
 * @param {object} provider
 * @param {object} config
 * @returns {object} provider object with network_affiliations field pruned
 */
const pruneIgnoredNetworkAffiliations = (provider, config) => {
    var _a;
    const networkAffiliations = provider.network_affiliations || [];
    const summaryDataConfig = (_a = config.provider_v9) === null || _a === void 0 ? void 0 : _a.summary_data;
    const networkAffiliationsSummaryDataConfig = (summaryDataConfig || []).find((c) => c.field === 'network_affiliations');
    const hasIgnoredValues = Array.isArray(networkAffiliationsSummaryDataConfig === null || networkAffiliationsSummaryDataConfig === void 0 ? void 0 : networkAffiliationsSummaryDataConfig.ignore) &&
        networkAffiliationsSummaryDataConfig.ignore.length > 0;
    if (hasIgnoredValues) {
        const prunedNetworkAffiliations = networkAffiliations.filter((n) => !((networkAffiliationsSummaryDataConfig === null || networkAffiliationsSummaryDataConfig === void 0 ? void 0 : networkAffiliationsSummaryDataConfig.ignore) || []).includes(n.name));
        return Object.assign(Object.assign({}, provider), { network_affiliations: prunedNetworkAffiliations });
    }
    return provider;
};
exports.pruneIgnoredNetworkAffiliations = pruneIgnoredNetworkAffiliations;
/**
 * Prunes ignored values off a field on a provider object
 * only works for array fields
 * @param {object} provider
 * @param {string} fieldKey
 * @param {object} config
 * @returns {object} provider object with fieldKey field pruned
 */
const pruneIgnoredValues = (provider, fieldKey, config) => {
    var _a;
    const fieldValues = provider[fieldKey] ||
        [];
    const summaryDataConfig = (_a = config.provider_v9) === null || _a === void 0 ? void 0 : _a.summary_data;
    const fieldSummaryDataConfig = (summaryDataConfig || []).find((c) => c.field === fieldKey);
    const hasIgnoredValues = Array.isArray(fieldSummaryDataConfig === null || fieldSummaryDataConfig === void 0 ? void 0 : fieldSummaryDataConfig.ignore) &&
        fieldSummaryDataConfig.ignore.length > 0;
    if (hasIgnoredValues) {
        const prunedFieldValues = fieldValues.filter((n) => !((fieldSummaryDataConfig === null || fieldSummaryDataConfig === void 0 ? void 0 : fieldSummaryDataConfig.ignore) || []).includes(n));
        return Object.assign(Object.assign({}, provider), { [fieldKey]: prunedFieldValues });
    }
    return provider;
};
exports.pruneIgnoredValues = pruneIgnoredValues;
/**
 * Returns a list of a provider's specialty and subspecialty names
 * @param {ProviderMatchProviderV9} provider a v9 provider object
 * @returns a list of the provider's specialties and subspecialty names
 */
const getSpecialtyItems = (provider) => {
    const specialtiesItems = (provider.specialties || []).reduce((acc, curr) => {
        const specialtyName = curr.name;
        const subspecialtyNames = curr.subspecialties && curr.subspecialties.length > 0
            ? curr.subspecialties.map((s) => s.name)
            : [];
        acc.push(specialtyName);
        subspecialtyNames.forEach((s) => acc.push(s));
        return acc;
    }, []);
    return specialtiesItems;
};
exports.getSpecialtyItems = getSpecialtyItems;
/**
 * Retrieves the phone contact value for a given provider.
 * @param provider - The provider object.
 * @returns The phone contact value if found, otherwise undefined.
 */
const getProviderPhone = (provider) => {
    var _a, _b;
    return (_b = (_a = provider === null || provider === void 0 ? void 0 : provider.contacts) === null || _a === void 0 ? void 0 : _a.find(({ contact_type }) => contact_type === 'phone')) === null || _b === void 0 ? void 0 : _b.value;
};
exports.getProviderPhone = getProviderPhone;
const getAboutSectionSummaryData = (config, provider) => {
    var _a;
    return (((_a = config.provider_v9) === null || _a === void 0 ? void 0 : _a.summary_data) || []).filter((fieldConfig) => !constants_1.ABOUT_SECTION_EXCLUDE_SUMMARY_DATA_FIELDS.includes(fieldConfig.field) &&
        (0, exports.summaryDataConfigHasProviderData)(fieldConfig, provider));
};
exports.getAboutSectionSummaryData = getAboutSectionSummaryData;
const showAboutSection = (config, provider) => {
    return (0, exports.getAboutSectionSummaryData)(config, provider).length > 0;
};
exports.showAboutSection = showAboutSection;
function showAppointmentsSection(config, provider) {
    if (!provider) {
        return false;
    }
    const bookingStrategy = (0, utilities_1.getBookingStrategy)(config, provider);
    switch (bookingStrategy) {
        case types_1.BookingStrategies.OpenSchedulingWidget:
            return true;
        case types_1.BookingStrategies.Availability:
        case types_1.BookingStrategies.Button:
        default:
            return false;
    }
}
exports.showAppointmentsSection = showAppointmentsSection;
function isProviderCompatibleWithOpenScheduling(openSchedulingConfig, provider) {
    const providerId = (0, utilities_2.getProviderIdForOpenScheduling)(provider);
    if (!providerId) {
        return false;
    }
    const visitTypes = (0, utilities_2.getVisitTypesFromProviderForOpenScheduling)(openSchedulingConfig, provider);
    if (visitTypes.length === 0) {
        return false;
    }
    return true;
}
exports.isProviderCompatibleWithOpenScheduling = isProviderCompatibleWithOpenScheduling;
const showClinicalInterestsSection = (provider) => {
    const { clinical_interests } = provider;
    return Boolean(clinical_interests) && typeof clinical_interests === 'string';
};
exports.showClinicalInterestsSection = showClinicalInterestsSection;
const showExpertiseSection = (provider) => {
    const { training, board_certifications, clinical_trials } = provider;
    const hasTraining = Array.isArray(training) && training.length > 0;
    const hasBoardCertifications = Array.isArray(board_certifications) && board_certifications.length > 0;
    const hasClinicalTrials = Array.isArray(clinical_trials) && clinical_trials.length > 0;
    return hasTraining || hasBoardCertifications || hasClinicalTrials;
};
exports.showExpertiseSection = showExpertiseSection;
const showInsuranceSection = (config, provider) => {
    const prunedInsuranceAccepted = (0, exports.pruneIgnoredValues)(provider, 'insurance_accepted', config).insurance_accepted;
    return prunedInsuranceAccepted.length > 0;
};
exports.showInsuranceSection = showInsuranceSection;
const showReviewSection = (provider) => {
    var _a;
    const { reviews } = provider;
    const aggregateRatings = reviews === null || reviews === void 0 ? void 0 : reviews.aggregate_ratings;
    if (!aggregateRatings) {
        return false;
    }
    const reviewCount = aggregateRatings.review_count;
    const ratingCount = aggregateRatings.rating_count;
    const hasDataForRatingsSection = typeof reviewCount === 'number' && typeof ratingCount === 'number';
    const hasDataForReviewsSection = Boolean((_a = reviews === null || reviews === void 0 ? void 0 : reviews.reviews) === null || _a === void 0 ? void 0 : _a.length);
    return hasDataForRatingsSection || hasDataForReviewsSection;
};
exports.showReviewSection = showReviewSection;
const showCareTeamSection = (config, careTeamProviders) => {
    var _a;
    return (((_a = config.feature_flags) === null || _a === void 0 ? void 0 : _a.provider_profile_care_team) === true &&
        (careTeamProviders === null || careTeamProviders === void 0 ? void 0 : careTeamProviders.length) > 0);
};
exports.showCareTeamSection = showCareTeamSection;
const showAltProvidersSection = (config, altProviders) => {
    return ((config === null || config === void 0 ? void 0 : config.show_provider_profile_alt_providers) === true &&
        (altProviders === null || altProviders === void 0 ? void 0 : altProviders.length) > 0);
};
exports.showAltProvidersSection = showAltProvidersSection;
//# sourceMappingURL=utils.js.map